import { Heading1Element, Heading2Element, Heading3Element } from '@typedream/components';
import { createTElementPluginFactory, createTPluginFactory } from '../../plate';
import { ELEMENT_H1, ELEMENT_H2, ELEMENT_H3 } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';

const createHeading1Plugin = createTElementPluginFactory({
  key: ELEMENT_H1,
  component: withDropTarget(Heading1Element),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/h1.png',
      title: 'Heading 1',
      subtitle: 'Big heading for titles',
      keywords: ['text', 'title'],
    },
    format: {
      formatType: 'block',
      placeholderText: 'Heading 1',
      focusableWhenEmpty: true,
      changeToParagraphOnBackspace: true,
      validProperties: [
        'width',
        'width_max',
        'align',
        'mobile_hide',
        'desktop_hide',
        'animation',
        'connect_data',
        'padding',
        'margin',
      ],
    },
  },
});

const createHeading2Plugin = createTElementPluginFactory({
  key: ELEMENT_H2,
  component: withDropTarget(Heading2Element),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/h2.png',
      title: 'Heading 2',
      subtitle: 'Mediu heading',
      keywords: ['text', 'title', 'subtitle'],
    },
    format: {
      formatType: 'block',
      placeholderText: 'Heading 2',
      focusableWhenEmpty: true,
      changeToParagraphOnBackspace: true,
      validProperties: [
        'width',
        'width_max',
        'align',
        'mobile_hide',
        'desktop_hide',
        'animation',
        'connect_data',
        'padding',
        'margin',
      ],
    },
  },
});

const createHeading3Plugin = createTElementPluginFactory({
  key: ELEMENT_H3,
  component: withDropTarget(Heading3Element),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/h3.png',
      title: 'Heading 3',
      subtitle: 'Small heading',
      keywords: ['text', 'title', 'subtitle'],
    },
    format: {
      formatType: 'block',
      placeholderText: 'Heading 3',
      focusableWhenEmpty: true,
      changeToParagraphOnBackspace: true,
      validProperties: [
        'width',
        'width_max',
        'align',
        'mobile_hide',
        'desktop_hide',
        'animation',
        'connect_data',
        'padding',
        'margin',
      ],
    },
  },
});

export const createHeadingPlugin = createTPluginFactory({
  key: 'heading',
  plugins: [createHeading1Plugin(), createHeading2Plugin(), createHeading3Plugin()],
});
